const ZONE_SHADOW = '0px 4px 8px 0px #621A20';
const CIRCLE_SHADOW = `2px 4px 16px rgba(110,111,94,0.30), ${ZONE_SHADOW}`;
const MASCOT_FILTER = 'drop-shadow(0px 4px 4px rgba(0,0,0,0.25))';

/**
 * 首頁／心傳頁共用的互動專區 pill 按鈕
 * pillWidth 預設固定寬（對齊首頁）；傳 "auto" 時依文字內容撐開，不影響其他用法
 */
export default function InteractiveZoneItem({
  href,
  enabled = true,
  onClick,
  iconSide = 'left',
  pillColor,
  pillInsetColor,
  pillPaddingLeft,
  pillPaddingRight,
  pillWidth = iconSide === 'left' ? 325 : 322,
  label,
  labelSpacing = 7,
  labelFontSize = 32,
  mascotSrc,
  mascotStyle,
}) {
  const isAutoWidth = pillWidth === 'auto';
  const pillLeft = iconSide === 'left' ? 25 : 0;
  const circleLeft = iconSide === 'left' ? 0 : 250;

  return (
    <a
      href={enabled ? href : undefined}
      aria-disabled={!enabled}
      tabIndex={!enabled ? -1 : 0}
      onClick={(e) => {
        if (!enabled) { e.preventDefault(); return; }
        onClick?.(e);
      }}
      style={{
        ...(isAutoWidth
          ? { display: 'inline-block', width: 'auto', paddingTop: 34 }
          : { display: 'block', width: 350 }),
        minHeight: 130,
        position: 'relative',
        opacity: enabled ? 1 : 0.45,
        pointerEvents: enabled ? 'auto' : 'none',
        cursor: enabled ? 'pointer' : 'not-allowed',
      }}
    >
      <div style={{
        width: isAutoWidth ? 'max-content' : pillWidth,
        paddingTop: 12,
        paddingBottom: 12,
        minHeight: 80,
        paddingLeft: pillPaddingLeft,
        paddingRight: pillPaddingRight ?? (isAutoWidth ? 28 : undefined),
        ...(isAutoWidth
          ? { position: 'relative', marginLeft: pillLeft }
          : { position: 'absolute', left: pillLeft, top: 34 }),
        background: pillColor,
        boxShadow: `0px 0px 4px 4px ${pillInsetColor} inset, ${ZONE_SHADOW}`,
        borderRadius: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: iconSide === 'right' ? 'flex-end' : 'flex-start',
        gap: 10,
      }}>
        <span style={{
          fontSize: labelFontSize,
          fontFamily: 'Noto Serif TC',
          fontWeight: 700,
          letterSpacing: labelSpacing,
          color: 'white',
          WebkitTextStroke: '5px black',
          paintOrder: 'stroke fill',
          lineHeight: 1.2,
          textAlign: iconSide === 'right' ? 'right' : 'left',
          wordBreak: 'break-word',
          display: 'block',
          whiteSpace: isAutoWidth ? 'nowrap' : 'pre-line',
        }}>
          {label}
        </span>
      </div>
      <div style={{ width: 100, height: 100, left: circleLeft, top: 22, position: 'absolute', background: 'rgba(197,155,90,0.16)', boxShadow: CIRCLE_SHADOW, borderRadius: 9999, border: '10px solid rgba(255,255,255,0.60)', backdropFilter: 'blur(4px)' }} />
      <img src={mascotSrc} alt="" style={{ objectFit: 'contain', filter: MASCOT_FILTER, position: 'absolute', ...mascotStyle }} />
    </a>
  );
}
